var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-datepicker", {
        attrs: {
          id: "dashboard-date-filter",
          locale: "es-ES",
          placeholder: "Clic para seleccionar",
          icon: "calendar",
          "icon-pack": "fa",
          range: "",
          "mobile-native": false,
          "trap-focus": "",
          "date-formatter": _vm.dateFormatter,
          rounded: "",
        },
        on: { input: _vm.emitRangeDateChangeEvent },
        model: {
          value: _vm.dates,
          callback: function ($$v) {
            _vm.dates = $$v
          },
          expression: "dates",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }